var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content example-md-doc"},[_c('div',{staticClass:"tip"},[_c('p',[_vm._v("当存在需要重复拷贝的数据，你可以像 excel 那样进行单元格内容的自动填充")])])])}]

export { render, staticRenderFns }